import { useAppDispatch } from "../redux/store";
import { setPaymentActionUrl } from "../redux/Slices/BillingSlice";
import { useSocketEvent } from "./useSocketEvent";

/** A32: remember the 3DS page Stripe asks the customer to open, until the
 * payment recovers. Mounted once, in DashboardLayout. */
export function usePaymentActionEvents(): void {
  const dispatch = useAppDispatch();
  useSocketEvent<{ liveStreamId?: string; hostedInvoiceUrl?: string | null }>(
    "payment_action_required",
    (event) => {
      if (event?.liveStreamId)
        dispatch(
          setPaymentActionUrl({
            streamId: event.liveStreamId,
            url: event.hostedInvoiceUrl ?? null,
          })
        );
    }
  );
  useSocketEvent<{ liveStreamId?: string }>("payment_recovered", (event) => {
    if (event?.liveStreamId)
      dispatch(setPaymentActionUrl({ streamId: event.liveStreamId, url: null }));
  });
}
